import { Component, Injectable, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import type { IndexWidget, Widget } from 'instantsearch.js';
import { PageEvent, MatPaginatorModule } from '@angular/material/paginator';

import { BaseHit } from 'instantsearch.js';
import { connectConfigure, connectHits, connectPagination, connectSearchBox } from 'instantsearch.js/es/connectors';


import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { TopSliderComponent } from '../top-slider/top-slider.component';
import { SearchInputComponent } from '../search-input/search-input.component';
import { SearchRes, SearchService } from '../../services/Search/search.service';
import { CommonModule } from '@angular/common';
import { PosterCardComponent } from "../poster-card/poster-card.component";
import { Movie, PageService } from '../../services/Page/page.service';
import { PosterListComponent } from "../poster-list/poster-list.component";
import { MatIconModule } from "@angular/material/icon";
import { SquareListComponent } from "../square-list/square-list.component";
import { TopImageRotatorComponent } from "../top-image-rotator/top-image-rotator.component";
import { SearchImageRotatorComponent } from "../search-image-rotator/search-image-rotator.component";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { OrderByDatePipe } from "../../pipes/order-by-date.pipe";
import { OrderSearchByDatePipe } from "../../pipes/order-search-by-date.pipe";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

// import '@angular/localize/init';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();

    // For internationalization, the `$localize` function from
    // the `@angular/localize` package can be used.
    firstPageLabel = `First page`;
    itemsPerPageLabel = `Items per page:`;
    lastPageLabel = `Last page`;

    // You can set labels to an arbitrary string too, or dynamically compute
    // it through other third-party internationalization libraries.
    nextPageLabel = 'Next page';
    previousPageLabel = 'Previous page';

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return `Page 1 of 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return `Page ${page + 1} of ${amountPages}`;
    }
}


@Component({
    selector: 'app-search-page',
    imports: [
        CommonModule,
        TopSliderComponent,
        SearchInputComponent,
        ReactiveFormsModule,
        PosterCardComponent,
        PosterListComponent,
        MatIconModule,
        SquareListComponent,
        TopImageRotatorComponent,
        SearchImageRotatorComponent,
        SafeHtmlPipe,
        OrderByDatePipe,
        OrderSearchByDatePipe,
        MatPaginatorModule,
        MatFormFieldModule
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }
    ],
    templateUrl: './search-page.component.html',
    styleUrl: './search-page.component.scss'
})
export class SearchPageComponent {
    searchControl = new FormControl('');
    results: any[] = [];
    public hits: BaseHit[] = [];
    public refine!: (query: string) => void;
    configureRefine: (params: any) => void = () => { }; // For setting filters
    public query!: string;
    public movies: Movie[] = []
    public franchises: Movie[] = []
    public cast: SearchRes[] = new Array<SearchRes>()
    public directors: SearchRes[] = []
    public filterCache: string = ''
    public isShowResults: boolean = true

    public searchInput: string = ''
    public showError: boolean = false

    public searchTimeout: any

    public skipSort: string = 'off'

    // paginator
    length = 13;
    pageSize = 10;
    pageIndex = 0;
    pageSizeOptions = [20];

    hidePageSize = true;
    showPageSizeOptions = true;
    showFirstLastButtons = true;
    disabled = false;

    pageEvent: PageEvent | undefined;
    refinePagination: any

    tempResults: boolean = false;

    public data = [
        {
            img: "https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/pageBg%2FLALA-Land-horizontal.jpg?alt=media&token=100b24e3-bb97-4941-b3df-e904eaf41bfe",
            search: 'La La Land',
        },
        {
            img: "https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/pageBg%2FDirty-Dancing-horizontal-01-v2.jpg?alt=media&token=bafc3e5e-ea8a-4a19-affa-94a7533c0184",
            search: "Dirty Dancing"
        },
        {
            img: 'https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/pageBg%2Fhunger-games-boss%2FThe-Hunger-Games-Ballad-Of-Songbirds-and-Snakes-horizontal-06.jpg?alt=media&token=639fffa9-80fd-4de1-9672-b0d0a404fc79',
            search: 'The Hunger Games Ballad Of Songbirds and Snakes'
        },
        {
            img: 'https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/pageBg%2Fnow-you-see-me-2%2FNow-You-See-Me-2-horizontal-02-v2.jpg?alt=media&token=cca669d3-a72b-49be-b67b-de95a40b7c8d',
            search: 'Now You See Me',
        }
    ]

    constructor(
        public searchService: SearchService,
        public pageService: PageService,
        private activatedRoute: ActivatedRoute
    ) {

        this.activatedRoute.paramMap.subscribe(params => {
            const query = params.get('query'); // 'id' is the parameter name from your route
            if (query && query != '') {
                this.searchService.searchText = query;
                this.searchText(query)
            }
        });

        this.searchService.genreSearch$.subscribe((genre) => {
            this.skipSort = 'off'
            if (genre && genre.length) {
                this.refine(this.searchInput)
                this.skipSort = 'skip'

                // this.pageService.getMoviesByGenre(genre).then(movies => {

                //     this.movies = movies
                //     if (movies.length > 0) {
                //         this.isShowResults = true
                //     }
                // })
            }
            else {
                if (this.searchInput != '' || this.searchService.activeRatingList.length > 0 || this.searchService.activeformatList.length > 0) {
                    this.refine(this.searchInput)
                }
                else {
                    this.isShowResults = false
                }
            }
        })

        this.searchService.ratingSearch$.subscribe((rating) => {
            if (rating && rating.length) {
                this.refine(this.searchInput)
            }
            else {
                if (this.searchInput != '' || this.searchService.activeGenreList.length > 0 || this.searchService.activeformatList.length > 0) {
                    this.refine(this.searchInput)
                }
                else {
                    this.isShowResults = false
                }
            }
        })

        this.searchService.formatSearch$.subscribe((format) => {
            if (format && format.length) {
                this.refine(this.searchInput)
            }
            else {
                if (this.searchInput != '' || this.searchService.activeGenreList.length > 0 || this.searchService.activeRatingList.length > 0) {
                    this.refine(this.searchInput)
                }
                else {
                    this.isShowResults = false
                }
            }
        })



        // Create a render function for your custom pagination
        const renderPagination = (renderOptions: { currentRefinement: any; nbPages: any; refine: any; }, isFirstRender: any) => {
            const { currentRefinement, nbPages, refine } = renderOptions;
            this.length = nbPages

            this.refinePagination = refine
            if (isFirstRender) {
                // You can attach event listeners here if needed for custom buttons
            }

            // Example: Programmatically go to the next page
            const goToNextPage = () => {
                if (currentRefinement < nbPages - 1) { // Check if it's not the last page
                    refine(currentRefinement + 1); // Increment the page
                }
            };

            // Example: Programmatically go to a specific page (e.g., page 5)
            const goToPageFive = () => {
                refine(4); // Page numbers are zero-based, so page 5 is index 4
            };

            // You would typically render buttons here and call goToNextPage or goToPageFive
            // based on user interaction. For programmatic control, you can call them directly.
            // For demonstration, let's just log them:
            // console.log('Current Page:', currentRefinement);
            // console.log('Total Pages:', nbPages);

            // You could call goToNextPage() here if you want to automatically advance
            // or expose these functions for external programmatic control.
        };

        // Create the custom pagination widget
        const customPagination = connectPagination(renderPagination);


        this.searchService.addWidgets([
            connectSearchBox(({ refine, query }) => {
                // this.refine = refine;
                this.refine = refine;
                this.query = query;
            })({
                // ...widgetParameters
            }),
            connectConfigure(({ refine }) => {
                this.configureRefine = refine;
                // Initial filter setup
                const initialFilters = this.buildFilters();
                if (this.filterCache != initialFilters.filters) {
                    this.filterCache = initialFilters.filters
                    refine(initialFilters);
                }
            })({
                searchParameters: {}
            }),
            customPagination({
                // Widget parameters (if any)
            }),
            connectHits(({ hits }) => {
                this.hits = hits;
                this.showError = false

                // this.isShowResults = false

                this.movies = []
                this.franchises = []
                this.cast = []
                this.directors = []

                // || hit['_highlightResult']['Title'].matchLevel == 'partial'

                let unfilteredIds = this.hits.map(hit => {

                    return hit['objectID']

                })

                // let ids = this.hits.map(hit => {
                //     if (hit['_highlightResult']['Title'].matchLevel == 'full') {
                //         return hit['objectID']
                //     }
                // })

                // ids = ids.filter(item => item != undefined)
                let franchises = this.hits.map(hit => {
                    if (hit['_highlightResult']['Franchise'] && hit['_highlightResult']['Franchise'].matchLevel == 'full') {
                        // return new Movie(hit)
                        let movie = new Movie(hit)
                        movie.Dx = hit['objectID']
                        return movie
                        // return hit['objectID']
                    }
                    return undefined
                })

                this.franchises = franchises.filter(item => item != undefined)
                
                let movies = this.hits.map(hit => {
                    if (hit['_highlightResult']['Title'].matchLevel == 'full') {
                        // return new Movie(hit)
                        let movie = new Movie(hit)
                        movie.Dx = hit['objectID']
                        return movie
                        // return hit['objectID']
                    }
                    return undefined
                })
                let filteredMovies = movies.filter(item => {

                    var foundItem = this.franchises.find(movie => {
                        return movie.Dx == item?.Dx
                    }) 
                    if(foundItem == undefined) return true 
                    
                    return false
                })

                this.movies = filteredMovies.filter(item => item != undefined)

                


                let castItems = this.hits.map(hit => {
                    // || hit['_highlightResult']['Cast'].matchLevel == 'partial'


                    var fullMatchList = hit['_highlightResult']['CastList'].filter((item: any) => {
                        if (item.matchLevel == 'full') {
                            return item
                        }
                    })


                    if (fullMatchList.length > 0 && fullMatchList[0] != undefined) {
                        return {
                            hitText: fullMatchList[0].value,
                            hit: hit
                        }
                    }
                    return undefined
                })
                castItems = castItems.filter(item => item != undefined)
                // let castIds = castItems.map(item => item?.id)
                this.cast = castItems.map(item => {
                    if (item) {
                        let movie: Movie = new Movie(item.hit)
                        movie.Dx = item.hit['objectID']
                        return new SearchRes(movie, item.hitText)
                    }
                    return new SearchRes(new Movie(), '')
                })



                let directorItems = this.hits.map(hit => {
                    // || hit['_highlightResult']['Director'].matchLevel == 'partial'
                    var fullMatchList2 = hit['_highlightResult']['DirectorList'].filter((item: any) => {
                        if (item.matchLevel == 'full') {
                            return item
                        }
                    })

                    if (fullMatchList2.length > 0 && fullMatchList2[0] != undefined) {
                        return {
                           hitText: fullMatchList2[0].value,
                            hit: hit
                        }
                    }
                    return undefined
                })
                directorItems = directorItems.filter(item => item != undefined)
                // let directorIds = directorItems.map(item => item?.id)
                this.directors = directorItems.map(item => {
                    if (item) {
                        let movie: Movie = new Movie(item.hit)
                        movie.Dx = item.hit['objectID']
                        return new SearchRes(movie, item.hitText)
                    }
                    return new SearchRes(new Movie(), '')
                })


                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    // this.pageService.getMoviesByIds(ids).then(movies => {
                    //     this.movies = movies
                    //     if (movies.length > 0) {
                    //         this.isShowResults = true
                    //     }
                    // })
                    if(this.franchises.length > 0) {
                        this.isShowResults = true
                    }

                    if (this.movies.length > 0) {
                        this.isShowResults = true
                    }
                    // this.pageService.getMoviesByIds(castIds).then(movies => {
                    // this.cast = movies.map(movie => {

                    //     let match = castItems.find(item => item?.id == movie.Dx)
                    //     let text = match?.hit && match?.hit != undefined ? match.hit : ''
                    //     return new SearchRes(movie, text)
                    // })

                    if (this.cast.length > 0) {
                        this.isShowResults = true
                    }
                    // })
                    // this.pageService.getMoviesByIds(directorIds).then(movies => {
                    //     // this.directors = movies
                    //     this.directors = movies.map(movie => {

                    //         let match = directorItems.find(item => item?.id == movie.Dx)
                    //         let text = match?.hit && match?.hit != undefined ? match.hit : ''
                    //         return new SearchRes(movie, text)
                    //     })


                    if (this.directors.length > 0) {
                        this.isShowResults = true
                    }
                    // })
                    if (this.movies.length == 0 && this.franchises.length == 0 && this.cast.length == 0 && this.directors.length == 0 && this.searchInput == '') {
                        this.isShowResults = false
                        // no search results match check genre results
                        if (this.searchService.activeGenreList.length > 0 || this.searchService.activeRatingList.length > 0 || this.searchService.activeformatList.length > 0) {

                            this.movies = this.hits.map(hit => {
                                let movie = new Movie(hit)
                                movie.Dx = hit['objectID']
                                return movie
                            })
                            if (movies.length > 0) {
                                this.isShowResults = true
                            }
                            else {
                                this.isShowResults = true
                                this.showError = true
                            }

                            // this.pageService.getMoviesByIds(unfilteredIds).then(movies => {
                            //     this.movies = movies
                            //     if (movies.length > 0) {
                            //         this.isShowResults = true
                            //     }
                            //     else {
                            //         this.isShowResults = true
                            //         this.showError = true
                            //     }
                            // })
                        }
                    }
                    else {
                        setTimeout(() => {
                            this.isShowResults = true
                            this.showError = true
                        }, 200);
                    }


                }, 10);



            })({}),
        ]);
    }

    ngAfterContentInit() {
        // this.searchService.start();

        setTimeout(() => {

            if (this.searchService.searchText != '') {
                this.searchText(this.searchService.searchText)
            }
        }, 500);
    }

    ngOnDestroy() {
        // Remove InstantSearch widgets when the component is destroyed
        this.closeResults()
        this.searchService.removeWidgets();
    }

    handlePageEvent(e: PageEvent) {
        this.pageEvent = e;
        this.length = e.length;
        this.pageSize = e.pageSize;
        this.pageIndex = e.pageIndex;
        this.refinePagination(this.pageIndex)
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        if (setPageSizeOptionsInput) {
            this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
        }
    }

    paginationNext() {
        this.searchService.instantSearchInstance.helper?.nextPage().search();
    }

    // Build filter string based on form values
    private buildFilters(): { filters: string } {
        const selectedGenres = this.searchService.activeGenreList
        const selectedRating = this.searchService.activeRatingList.length ? this.searchService.activeRatingList[0] : null
        let selectedFormat = this.searchService.activeformatList.length ? this.searchService.activeformatList[0] : null

        let filters = '';

        // Add genre filters with AND logic
        if (selectedGenres.length > 0) {
            filters = selectedGenres.map((genre: string) => `GenreList:"${genre}"`).join(' AND ');
        }

        // Add rating filter
        if (selectedRating) {
            filters = filters ? `${filters} AND Rating:"${selectedRating}"` : `Rating:"${selectedRating}"`;
        }

        // Add rating filter
        if (selectedFormat) {
            filters = filters ? `${filters} AND FormatList:"${selectedFormat}"` : `FormatList:"${selectedFormat}"`;
        }

        return { filters };
    }

    public search(event: Event) {
        this.refine!((event.target as HTMLInputElement).value);
        // this.isShowResults = true
        this.searchInput = (event.target as HTMLInputElement).value
    }

    public searchText(text: string) {
        if(this.searchService.isTempSearch) {
            this.searchService.clearAllGenre()
        }
        this.refine!(text);
        this.searchInput = text
        // this.isShowResults = true
    }

    public closeResults() {
        this.searchInput = ''
        this.searchService.searchText = ''
        this.isShowResults = false
        this.showError = false
        this.searchService.clearAllGenre()
        this.searchService.clearAllRating()
        this.searchService.clearAllFormat()
        this.refine('')
         // Reset pagination to first page
        this.pageIndex = 0;
        if (this.refinePagination) {
            this.refinePagination(0);
        }
    }

    public closeGenreFilter() {
        this.searchService.closeGenreFilter()
    }

    public closeFormatFilter() {
        this.searchService.closeFormatFilter()
    }

    public genreItemClick(genre: any, index: number) {
        this.searchService.toggleGenre(genre.search)
    }

    public formatItemClick(format: any, index: number) {
        this.searchService.toggleFormat(format.search)
    }

    public closeRatingFilter() {
        this.searchService.closeRatingFilter()
    }

    public ratingItemClick(rating: any, index: number) {
        this.searchService.toggleRating(rating.search)
    }
}
